module.exports = __webpack_public_path__ + "img/1.5 px.3eab0ef5.svg";